// Read-only patient record. Grouped into Personal / Contact / Address /
// Account cards (DetailSection) instead of one flat 18-field grid, so a
// specific field is found by section rather than by scanning the whole page.
import { Field, Section } from "../../DetailSection/DetailSection";
import "Colors.css";

export const GeneralInfoView = ({ patientDetails }) => {
  const fullName = [
    patientDetails.prefix,
    patientDetails.firstName,
    patientDetails.middleName,
    patientDetails.lastName,
    patientDetails.suffix,
  ]
    .filter((part) => part && part !== "-")
    .join(" ");

  return (
    <div className="flex flex-col gap-4">
      <Section title="Personal" columns={3}>
        <Field label="Full Name" value={fullName} />
        <Field label="Date of Birth" value={patientDetails.DOB} />
        <Field label="Gender" value={patientDetails.gender} />
        <Field label="Prefix" value={patientDetails.prefix} />
        <Field label="First Name" value={patientDetails.firstName} />
        <Field label="Middle Name" value={patientDetails.middleName} />
        <Field label="Last Name" value={patientDetails.lastName} />
        <Field label="Suffix" value={patientDetails.suffix} />
      </Section>

      <Section title="Contact" columns={3}>
        <Field label="Email" value={patientDetails.userName} />
        <Field label="Phone Number" value={patientDetails.phoneNumber} />
        <Field label="Phone Type" value={patientDetails.phoneType} />
      </Section>

      <Section title="Address" columns={3}>
        <Field label="Address Line 1" value={patientDetails.address1} />
        <Field label="Address Line 2" value={patientDetails.address2} />
        <Field label="City" value={patientDetails.city} />
        <Field label="State" value={patientDetails.state} />
        <Field label="ZIP Code" value={patientDetails.zipCode} />
        <Field label="Country" value={patientDetails.country} />
      </Section>

      <Section title="Account" columns={2}>
        <Field label="Membership" value={patientDetails.memberShipPlan} />
        <Field label="Patient ID" value={patientDetails.cognitoId} />
      </Section>
    </div>
  );
};
